import { Link } from "react-router-dom";
import { Button } from "@/components/ui";

export function NotFound() {
  return (
    <div className="grid min-h-dvh place-items-center bg-ink-100 px-4 text-center">
      <div>
        <p className="font-mono text-sm text-ink-400">404</p>
        <h1 className="mt-2 text-2xl font-semibold tracking-tight">That page has moved on</h1>
        <p className="mt-1 text-sm text-ink-400">The link may be old, or the shipment may have been removed.</p>
        <Link to="/app" className="mt-6 inline-block">
          <Button>Back to your dashboard</Button>
        </Link>
      </div>
    </div>
  );
}
